/** Encodes an app config as a base64 JSON string for injection into HTML. */
export function encodeAppConfig(config: unknown): string {
  return btoa(JSON.stringify(config));
}

/** Decodes a base64 JSON string back to an app config. */
export function decodeAppConfig<T>(encoded: string): T {
  const json = atob(encoded);
  return JSON.parse(json) as T;
}
